import angular from 'angular';
import { AngularServices } from '../../../modules/core';
import { VideoQuality } from '../../../modules/call/constants';
import { RootScopeEvents } from '../root-scope-types';
export class VideoQualityService {
    /* @ngInject */
    constructor($rootScope, $log, pn, $translate, Browser) {
        this.$rootScope = $rootScope;
        this.$log = $log;
        this.pn = pn;
        this.$translate = $translate;
        this.Browser = Browser;
        this.qualities = Object.values(VideoQuality);
        this.debug = $log.debug.bind($log, 'VideoQuality:');
        this.currentQuality = Browser.supportsOnlySDQuality()
            ? VideoQuality.Medium
            : VideoQuality.Low;
    }
    get options() {
        return {
            [VideoQuality.Low]: this.$translate.instant('video-chat.call-quality.options.ld'),
            [VideoQuality.Medium]: this.$translate.instant('video-chat.call-quality.options.sd'),
            [VideoQuality.High]: this.$translate.instant('video-chat.call-quality.options.hd'),
        };
    }
    get current() {
        return this.currentQuality;
    }
    canSwitchQuality() {
        return !this.Browser.isHandheld();
    }
    async switchTo(quality) {
        this.debug(`switchTo: from ${this.currentQuality}, to ${quality}`);
        if (this.Browser.supportsOnlySDQuality()) {
            return;
        }
        if (!this.canSwitchQuality() || !this.qualities.includes(quality)) {
            quality = VideoQuality.Low;
        }
        if (this.currentQuality === quality) {
            return;
        }
        this.currentQuality = quality;
        this.$rootScope.$emit(RootScopeEvents.CHANGE_VIDEO_QUALITY, { quality });
        return this.pn.setState({ quality });
    }
}
export default angular
    .module('doxy.common.services.videoQuality', [])
    .service(AngularServices.VideoQualityService, VideoQualityService).name;
